import { useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Collapse,
  Divider,
  Typography,
} from "@mui/material";

import { summaryInfo } from "@/utils/staticData/checkoutData";

import AddIcon from "@mui/icons-material/Add";
import ApplyPromo from "./components/ApplyPromo";
import CartSummary from "../CartSummary";
import Heading from "../components/Heading";
import Notification from "@/components/Notification/Notification";

interface IProps {
  setOrderSummary: React.Dispatch<React.SetStateAction<IOrderSummary>>;
  orderSummary: IOrderSummary;
}
const OrderSummary: React.FC<IProps> = ({ setOrderSummary, orderSummary }) => {
  const [promoIsOpen, setPromoIsOpen] = useState(false);
  const [notificationIsOpen, setNotificationIsOpen] = useState(false);

  const togglePromo = () => {
    setPromoIsOpen((prevState) => !prevState);
  };

  const onPromoSubmit = () => {
    togglePromo();
    setNotificationIsOpen(true);

    setTimeout(() => {
      setNotificationIsOpen(false);
    }, 2500);
  };
  return (
    <>
      <Heading title="OrderSummary" mb={4} />
      <CartSummary
        orderSummary={orderSummary}
        setOrderSummary={setOrderSummary}
      />
      <Divider />

      {/* Open / close promo button */}
      <Collapse in={!promoIsOpen}>
        <Button
          variant="text"
          fullWidth
          endIcon={<AddIcon />}
          sx={{ justifyContent: "space-between", px: 0, py: 3 }}
          onClick={togglePromo}
        >
          Apply promo
        </Button>
      </Collapse>

      {/* Promo input/form */}
      <Collapse in={promoIsOpen}>
        <ApplyPromo
          setOrderSummary={setOrderSummary}
          onPromoSubmit={onPromoSubmit}
        />
      </Collapse>

      <Divider />
      <Box
        display="flex"
        flexDirection="column"
        gap={{ xs: 3, md: 4 }}
        mt={{ xs: 4, md: 5, lg: 6 }}
      >
        {summaryInfo.map(({ title, text, iconUrl }, index) => (
          <Box key={index}>
            <Box
              display="flex"
              gap={{ xs: 1.5, md: 2 }}
              sx={{ "& .MuiAvatar-root": { width: 24, height: 24 } }}
            >
              <Avatar src={iconUrl} />
              <Typography
                variant="subtitle1"
                fontWeight={700}
                component="p"
                mb={1}
                color="text.primary"
              >
                {title}
              </Typography>
            </Box>
            <Typography
              ml={{ xs: 4.25, md: 5 }}
              variant="body1"
              color="text.secondary"
            >
              {text}
            </Typography>
          </Box>
        ))}
      </Box>

      <Notification
        open={notificationIsOpen}
        onClose={() => setNotificationIsOpen(false)}
        title="Promo code successfully entered"
        description="Your changes have been saved and your profile is live. Your team can make edits."
      />
    </>
  );
};

export default OrderSummary;
